// components/FinancialLiteracyLessonRenderer.js - Web version lesson router
import React from 'react';

// Import Chapter 1 lessons
import Chapter1Lesson1 from '../chapters/Chapter1/Chapter1Lesson1';
import Chapter1Lesson2 from '../chapters/Chapter1/Chapter1Lesson2';
// import Chapter1Lesson3 from '../chapters/Chapter1/Chapter1Lesson3';
// import Chapter1Lesson4 from '../chapters/Chapter1/Chapter1Lesson4';
// import Chapter1Lesson5 from '../chapters/Chapter1/Chapter1Lesson5';

// Import Chapter components for fallback
import Chapter1 from '../chapters/Chapter1';

// Import Chapter 2 lessons when you create them
// import Chapter2Lesson1 from '../chapters/Chapter2/Chapter2Lesson1';
// import Chapter2Lesson2 from '../chapters/Chapter2/Chapter2Lesson2';
// import Chapter2 from '../chapters/Chapter2';

const FinancialLiteracyLessonRenderer = ({ chapterId, lessonId, child, family, onNavigate }) => {
  console.log('🎯 FinancialLiteracyLessonRenderer - chapterId:', chapterId, 'lessonId:', lessonId);
  
  // Route to Chapter 1 lessons
  if (chapterId === '1') {
    switch (lessonId) {
      case '1':
        return (
          <Chapter1Lesson1 
            chapterId={chapterId} 
            lessonId={lessonId} 
            child={child} 
            family={family} 
            onNavigate={onNavigate} 
          />
        );
      case '2':
        return (
          <Chapter1Lesson2 
            chapterId={chapterId} 
            lessonId={lessonId} 
            child={child} 
            family={family} 
            onNavigate={onNavigate} 
          />
        );
      case '3':
        return (
          <div className="min-h-screen bg-gradient-to-b from-blue-50 to-green-50 flex items-center justify-center">
            <div className="text-center">
              <div className="text-6xl mb-4">🚧</div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Lesson Coming Soon!</h2>
              <p className="text-gray-600 mb-6">Chapter 1, Lesson 3 is currently being developed.</p>
              <button
                onClick={() => onNavigate('financialLiteracyChapter', { chapterId })}
                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg transition-colors"
              >
                ← Back to Chapter 1
              </button>
            </div>
          </div>
        );
      case '4':
        return (
          <div className="min-h-screen bg-gradient-to-b from-blue-50 to-green-50 flex items-center justify-center">
            <div className="text-center">
              <div className="text-6xl mb-4">🚧</div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Lesson Coming Soon!</h2>
              <p className="text-gray-600 mb-6">Chapter 1, Lesson 4 is currently being developed.</p>
              <button
                onClick={() => onNavigate('financialLiteracyChapter', { chapterId })}
                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg transition-colors"
              >
                ← Back to Chapter 1
              </button>
            </div>
          </div>
        );
      case '5':
        return (
          <div className="min-h-screen bg-gradient-to-b from-blue-50 to-green-50 flex items-center justify-center">
            <div className="text-center">
              <div className="text-6xl mb-4">🚧</div>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Lesson Coming Soon!</h2>
              <p className="text-gray-600 mb-6">Chapter 1, Lesson 5 is currently being developed.</p>
              <button
                onClick={() => onNavigate('financialLiteracyChapter', { chapterId })}
                className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg transition-colors"
              >
                ← Back to Chapter 1
              </button>
            </div>
          </div>
        );
      default:
        // If lesson not found, redirect to chapter
        console.log('❌ Chapter 1 Lesson not found, redirecting to chapter');
        return (
          <Chapter1 
            chapterId={chapterId} 
            child={child} 
            family={family} 
            onNavigate={onNavigate} 
          />
        );
    }
  }

  // Route to Chapter 2 lessons (when you create them)
  // if (chapterId === '2') {
  //   switch (lessonId) {
  //     case '1':
  //       return (
  //         <Chapter2Lesson1 
  //           chapterId={chapterId} 
  //           lessonId={lessonId} 
  //           child={child} 
  //           family={family} 
  //           onNavigate={onNavigate} 
  //         />
  //       );
  //     case '2':
  //       return (
  //         <Chapter2Lesson2 
  //           chapterId={chapterId} 
  //           lessonId={lessonId} 
  //           child={child} 
  //           family={family} 
  //           onNavigate={onNavigate} 
  //         />
  //       );
  //     default:
  //       return (
  //         <Chapter2 
  //           chapterId={chapterId} 
  //           child={child} 
  //           family={family} 
  //           onNavigate={onNavigate} 
  //         />
  //       );
  //   }
  // }

  // For chapters that don't exist yet, show coming soon
  const chapterNumber = parseInt(chapterId);
  if (chapterNumber > 1) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-blue-50 to-green-50 flex items-center justify-center">
        <div className="text-center">
          <div className="text-6xl mb-4">🚧</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-4">Chapter Coming Soon!</h2>
          <p className="text-gray-600 mb-6">Chapter {chapterNumber} is currently being developed.</p>
          <button
            onClick={() => onNavigate('financialLiteracyProgram')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg transition-colors"
          >
            ← Back to Program
          </button>
        </div>
      </div>
    );
  }

  // Fallback to Chapter 1 if something goes wrong
  console.log('❌ Fallback to Chapter 1');
  return (
    <Chapter1 
      chapterId="1" 
      child={child} 
      family={family} 
      onNavigate={onNavigate} 
    />
  );
};

export default FinancialLiteracyLessonRenderer;